var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationError = function SvgNotificationError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF6761"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.778A7.778 7.778 0 1 0 8 .222a7.778 7.778 0 0 0 0 15.556m0-1.334A6.444 6.444 0 1 1 8 1.556a6.444 6.444 0 0 1 0 12.888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.662 5.395 5.395 9.662a.667.667 0 0 0 .943.943l4.267-4.267a.667.667 0 0 0-.943-.943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.395 6.338 4.267 4.267a.667.667 0 0 0 .943-.943L6.338 5.395a.667.667 0 1 0-.943.943"
  }))));
};
export default SvgNotificationError;